import LegalLayout, {
    LegalSection,
} from "@/components/legal/LegalLayout";
import { CONTACT_EMAIL, CONTACT_PHONE } from "@/lib/brand";

export default function TermsConditions() {
    return (
        <LegalLayout
            testId="terms-conditions-page"
            eyebrow="Legal"
            title="Terms & Conditions"
            lastUpdated="December 2025"
            intro="These Terms & Conditions govern your access to and use of the RecoveryDesk website and services. By accessing the site, contacting us, or engaging our services, you acknowledge that you have read, understood, and agreed to these terms."
        >
            <LegalSection heading="1. Acceptance Of Terms" testId="terms-acceptance">
                <p>
                    By visiting recoverydesk.live, submitting our contact form,
                    or otherwise interacting with our services, you agree to be
                    bound by these Terms &amp; Conditions and our Privacy
                    Policy. If you do not agree, please do not use the website
                    or services.
                </p>
            </LegalSection>

            <LegalSection heading="2. The RecoveryDesk Service" testId="terms-service">
                <p>
                    RecoveryDesk provides web design and development services
                    for small and medium-sized businesses — including custom
                    website design, modern development, mobile-responsive
                    builds, SEO foundation, ongoing maintenance, and managed
                    hosting. Specific features and deliverables included in the
                    Web Development package may evolve over time as the
                    platform is updated and refined.
                </p>
            </LegalSection>

            <LegalSection heading="3. Acceptable Use" testId="terms-acceptable-use">
                <p>You agree that you will not:</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>
                        Use the service in any way that violates applicable
                        law or regulation.
                    </li>
                    <li>
                        Attempt to access, tamper with, or disrupt any portion
                        of the website, services, accounts, or underlying
                        infrastructure.
                    </li>
                    <li>
                        Submit false, misleading, or fraudulent information
                        through any form or communication channel.
                    </li>
                    <li>
                        Use the service to harass, defame, or harm others, or
                        to transmit unlawful or unwanted content.
                    </li>
                </ul>
            </LegalSection>

            <LegalSection heading="4. Intellectual Property" testId="terms-ip">
                <p>
                    The RecoveryDesk name, logo, branding, content, and
                    software are the property of RecoveryDesk or its licensors
                    and are protected by intellectual property laws. You may
                    not copy, modify, distribute, or create derivative works
                    based on our materials without our prior written consent.
                </p>
            </LegalSection>

            <LegalSection heading="5. Disclaimer Of Warranties" testId="terms-warranties">
                <p>
                    The website and services are provided on an &quot;as
                    is&quot; and &quot;as available&quot; basis. To the maximum
                    extent permitted by applicable law, RecoveryDesk disclaims
                    all warranties, express or implied, including any implied
                    warranties of merchantability, fitness for a particular
                    purpose, and non-infringement. We do not warrant that the
                    services will be uninterrupted, error-free, or free from
                    harmful components.
                </p>
            </LegalSection>

            <LegalSection heading="6. Limitation Of Liability" testId="terms-liability">
                <p>
                    To the maximum extent permitted by applicable law, in no
                    event will RecoveryDesk, its affiliates, or its service
                    providers be liable for any indirect, incidental, special,
                    consequential, or punitive damages, including lost profits,
                    lost data, or business interruption, arising out of or in
                    connection with your use of the website or services. Our
                    total cumulative liability for any claims arising under
                    these terms will not exceed the amounts you have paid to
                    RecoveryDesk in the twelve (12) months preceding the
                    claim.
                </p>
            </LegalSection>

            <LegalSection heading="7. Changes To These Terms" testId="terms-changes">
                <p>
                    We may update these Terms &amp; Conditions from time to
                    time. When we do, we will update the &quot;Last
                    Updated&quot; date at the top of this page. Continued use
                    of the website or services after changes have been posted
                    constitutes your acceptance of the updated terms.
                </p>
            </LegalSection>

            <LegalSection heading="8. Governing Law" testId="terms-governing-law">
                <p>
                    These Terms &amp; Conditions are governed by and construed
                    in accordance with the laws of the State of South Carolina,
                    United States, without regard to its conflict of laws
                    principles.
                </p>
            </LegalSection>

            <LegalSection heading="9. Contact Us" testId="terms-contact">
                <p>
                    For questions about these Terms &amp; Conditions, contact
                    us at:
                </p>
                <ul className="list-none pl-0 space-y-1">
                    <li>
                        <span className="text-[#888] mr-2 uppercase tracking-[0.2em] text-[11px]">
                            Email
                        </span>
                        <a
                            href={`mailto:${CONTACT_EMAIL}`}
                            className="text-[#D4AF37] hover:text-[#E5C158] transition-colors"
                        >
                            {CONTACT_EMAIL}
                        </a>
                    </li>
                    <li>
                        <span className="text-[#888] mr-2 uppercase tracking-[0.2em] text-[11px]">
                            Phone
                        </span>
                        <a
                            href={`tel:+1${CONTACT_PHONE.replace(/[^0-9]/g, "")}`}
                            className="text-[#D4AF37] hover:text-[#E5C158] transition-colors"
                        >
                            {CONTACT_PHONE}
                        </a>
                    </li>
                </ul>
            </LegalSection>
        </LegalLayout>
    );
}
